import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";
import { useDispatch, useSelector } from "react-redux";
import FilterDropDown from "../../../../../ReusableComponents/FilterDropDown/FilterDropDown";
import { useNavigate } from "react-router-dom";

export default function RequestProfessionChanges({
  token,
  data,
  setPopUp,
  apiCall,
  listData,
}) {
  console.log("................log print in the console", listData);
  useEffect(() => {
    getDropDownListData();
  }, []);

  console.log("listData.......", listData);
  const [file, setFile] = useState("");
  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    // console.log(selectedFiles);
    setFile(selectedFiles);
  };

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [Data, setFormData] = useState({
    application_date: "",
    new_visa_profession: "",
    new_visa_provider: "",
    new_visa_profession_level: "",
    fee_as_per_contract: "",
    fee_as_per_new_profession_level: listData.service_charge,
    new_profession_change_fee: "",
    borne_by: "",
  });

  const navigate = useNavigate();

  const setDataVisa = (event) => {
    setFormData({
      ...Data,
      new_visa_profession_level: event.target.value,
    });
  };
  const setDataProvider = (event) => {
    setFormData({
      ...Data,
      new_visa_provider: event.target.value,
    });
  };
  const [dropDoenList, SetDropDownList] = React.useState([]);

  const getDropDownListData = async () => {
    try {
      const result = await nodeinstance.get(
        "/visaProfession/profession_levels",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = result?.data?.data;
      SetDropDownList(data);
    } catch (error) {
      dispatch(setAppError({ msg: `${error?.message}` }));
    }
  };

  const submitHandler = async (e) => {
    // alert(".................")
    e.preventDefault();
    // setLoading(true);
    console.log(
      ".....................",
      listData.visa_profession,
      Data.new_visa_profession_level
    );
    if (listData.visa_profession === Data.new_visa_profession_level) {
      // alert(".................")
      dispatch(
        setAppError({
          msg: "Visa profession cannot be same.",
        })
      );
      return;
    }
    try {
      const formData = new FormData();

      // Assuming the file object is structured as shown
      Object.keys(file).forEach((key) => {
        const fileData = file[key]; // Access the individual file object
        if (fileData instanceof File) {
          formData.append("file", fileData); // Append each file to FormData
        }
      });

      formData.append("employee_id", data.employee_id),
        formData.append("application_date", Data.application_date),
        formData.append("new_visa_provider", Data.new_visa_provider), // Replace or remove based on actual usage
        formData.append("new_visa_profession_level", Data.new_visa_profession),
        formData.append("new_visa_profession", Data.new_visa_profession_level),
        formData.append("fee_as_per_contract", Data.fee_as_per_contract),
        formData.append(
          "fee_as_per_new_profession_level",
          Data.fee_as_per_new_profession_level
        ),
        formData.append(
          "new_profession_change_fee",
          Data.new_profession_change_fee
        ),
        formData.append("borne_by", Data.borne_by);

      // Send FormData via API
      const res = await nodeinstance.post("/visaProfession/update", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.status === 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        // navigate(`/dashboard/fin-visa-profession-changes`);
        setPopUp(false);
        apiCall();
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    } finally {
      setLoading(false);
    }
  };

  console.log("Imported file to be seen in the console", file);
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center flex`}
      >
        <div className="max-w-xl w-full max-h-[35rem] min-h-[15rem] overflow-scroll  rounded-md bg-white/95 flex  flex-col py-4 px-8 relative ">
          <div className="flex justify-between items-center w-full mt-1 mb-3">
            <h1 className="text-xl font-semibold">Request Profession Change</h1>
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp();
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form
            onSubmit={submitHandler}
            className="w-full flex flex-col my-4 gap-3"
          >
            <div className="flex flex-col gap-1">
              <label className="text-sm">Application Date</label>
              <input
                type="date" // Change input type to text
                id="field2"
                className={`input input-sm h-10 max-w-xs pl-6 w-full input-bordered focus:outline-none uppercase`}
                required
                onChange={(e) =>
                  setFormData({ ...Data, application_date: e.target.value })
                }
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm">New Visa Profession</label>

              <FilterDropDown
                onChange={setDataVisa}
                title={"New Visa Profession"}
                url={`/visaProfession/profession`}
                token={token}
                selectedStatus={Data.new_visa_profession_level}
              />
            </div>

            {/* <div className="flex flex-col gap-1">
              <label className="text-sm">New Visa Provider</label>
              <FilterDropDown
                onChange={setDataProvider}
                title={"New Visa Provider"}
                url={`/sadaad/visa-providers`}
                token={token}
                selectedStatus={formData.new_visa_provider}
              />
            </div> */}

            <div className="flex flex-col gap-1">
              <label className="text-sm">New Profession Level</label>
              <select
                className="select select-sm select-bordered uppercase h-10 w-48"
                onChange={(event) => {
                  const selectedId = event.target.value; // Get the selected value
                  const selectedOption = dropDoenList.find(
                    (option) => option.name === selectedId
                  ); // Find the corresponding option object
                  console.log(selectedOption); // Log the ID of the selected option
                  const total =
                    parseInt(selectedOption.admin_fee) +
                    parseInt(selectedOption.nitakat) +
                    parseInt(selectedOption.soundline_fee);
                  setFormData({
                    ...Data,
                    fee_as_per_contract: total,
                    new_visa_profession: selectedId,
                  });
                }}
              >
                <option value="">New Profession Level</option>
                {dropDoenList.map((filetype) => (
                  <option key={filetype?.id} value={filetype?.name}>
                    {filetype?.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-sm">
                Nitakat+Admin+SL Fees as per Contract
              </label>
              <input
                disabled={true}
                value={Data.fee_as_per_contract}
                type="number"
                step={"0.01"}
                className="input input-sm input-bordered"
                required
                pattern="[0-9]*"
                // onChange={(e) =>
                //   setFormData({
                //     ...formData,
                //     fee_as_per_contract: e.target.value,
                //   })
                // }
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-sm">
                Nitakat+Admin+SL Fees as per Profession level
              </label>
              <input
                value={Data.fee_as_per_new_profession_level}
                name="bankName"
                type="number"
                step={"0.01"}
                className="input input-sm input-bordered"
                required
                pattern="[0-9]*"
                onChange={(e) =>
                  setFormData({
                    ...Data,
                    fee_as_per_new_profession_level: e.target.value,
                  })
                }
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm">New profession Change Fees</label>
              <input
                type="number"
                step={"0.01"}
                className="input input-sm input-bordered"
                required
                pattern="[0-9]*"
                onChange={(e) =>
                  setFormData({
                    ...Data,
                    new_profession_change_fee: e.target.value,
                  })
                }
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm">
                Upload Employee Muqeem Documents
              </label>
              <input
                type="file"
                className="file-input file-input-bordered w-full"
                onChange={handleFileChange}
                required
                accept="application/.pdf"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm">Borne By</label>
              <div className="flex items-center space-x-8">
                <label>
                  <input
                    type="radio"
                    name="borneBy"
                    value="SLA"
                    onChange={(e) =>
                      setFormData({ ...Data, borne_by: e.target.value })
                    }
                    required
                  />
                  <span className="ml-2">SLA</span>
                </label>
                <label>
                  <input
                    type="radio"
                    name="borneBy"
                    value="Client"
                    onChange={(e) =>
                      setFormData({ ...Data, borne_by: e.target.value })
                    }
                    required
                  />
                  <span className="ml-2">Client</span>
                </label>
                <label>
                  <input
                    type="radio"
                    name="borneBy"
                    value="Employee"
                    onChange={(e) =>
                      setFormData({ ...Data, borne_by: e.target.value })
                    }
                    required
                  />
                  <span className="ml-2">Employee</span>
                </label>
              </div>
            </div>
            <div className="flex  gap-3 mx-auto my-3 w-full px-5">
              <button
                type="submit"
                className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
              >
                <p>Submit</p>
                {loading ? <CgSpinner className="animate-spin" /> : ""}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
